var chunkMapping = {
	"5228": [
		75228
	],
	"6179": [
		62797,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	],
	"8186": [
		99406
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		20948
	],
	"7293": [
		"default",
		"./AppLoader",
		20948
	],
	"17418": [
		"default",
		"./appSlice",
		20948
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		20948
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		20948
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		20948
	],
	"49394": [
		"default",
		"./store",
		20948
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		20948
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		20948
	],
	"75228": [
		"default",
		"./utils/constants",
		20948
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		20948
	],
	"85646": [
		"default",
		"./headerSlice",
		20948
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		20948
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		20948
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		20948
	],
	"99406": [
		"default",
		"./providers/FlagsmithProvider",
		20948
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	],
	"99406": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 20948
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}